import { Image } from 'interfaces/image';
import React from 'react';
import { theme } from 'theme/App.theme';
import { useStyles } from './Picture.styles';

export interface IPicture {
  image: Image | null | undefined;
  classNames?: { img?: any; picture?: string; container?: any };
  isDecorative?: boolean;
}

export function Picture({
  image,
  classNames,
  isDecorative,
}: IPicture): JSX.Element {
  const classes = useStyles();
  const breakpoints = theme.breakpoints.values;

  const imgClassNames = classNames && classNames.img ? classNames.img : '';
  const pictureClassNames =
    classNames && classNames.picture ? classNames.picture : '';

  return (
    <div className={`${classNames?.container} ${classes.container}`}>
      {image?.sources && (
        <picture className={`${pictureClassNames} `}>
          {image.sources.xLarge && (
            <source
              id="xLargeSource"
              media={`(min-width:${breakpoints.viewportXLarge}px)`}
              srcSet={image.sources.xLarge}
            />
          )}
          {image.sources.large && (
            <source
              id="largeSource"
              media={`(min-width:${breakpoints.viewportLarge}px)`}
              srcSet={image.sources.large}
            />
          )}
          {image.sources.medium && (
            <source
              id="mediumSource"
              media={`(min-width:${breakpoints.viewportMedium}px)`}
              srcSet={image.sources.medium}
            />
          )}
          <img
            alt={isDecorative ? '' : image.alternativeText}
            src={image.sources.small}
            className={`${classes.imageTag} ${imgClassNames}`}
          />
        </picture>
      )}
    </div>
  );
}
